import { Button, Form, Input, Popconfirm, Switch, Typography } from "antd";
import { nameRules } from "common/FormValidationRules";
import FormattedDateInput from "components/atoms/FormattedDateInput";
import _ from "lodash";
import validator from "validator";

const AdminTenantForm = ({ tenant, onUpdateTenant, onSetGoldenMaintenance, switchingGoldenMaintenance = false, ...props }) => {
    const [form] = Form.useForm();
    const goldenMaintenanceOn = !!(tenant.features && tenant.features.goldenMaintenance);

    const onFormSubmit = (tenantValues) => {
        let updateKeys = ["primaryContactName", "primaryContactEmail"];
        let updatedTenantValues = {};
        for (let key of updateKeys) {
            if (tenantValues[key] && tenantValues[key] !== tenant[key]) {
                updatedTenantValues[key] = tenantValues[key];
            }
        }

        if (_.isEmpty(updatedTenantValues) === false) {
            onUpdateTenant(tenant.tenantId, updatedTenantValues);
        }
    };

    return (
        <Form form={form} initialValues={tenant} onFinish={onFormSubmit} layout="horizontal" name="basic" className="w-full flex-1 rounded-md bg-gray-50 p-3">
            <div className="grid w-full grid-cols-3 gap-x-8 gap-y-3 *:!mb-0">
                <Form.Item label="Email Domain" name={["domain"]}>
                    <Input readOnly={true} />
                </Form.Item>

                <Form.Item label="Company" name={["company"]}>
                    <Input readOnly={true} />
                </Form.Item>

                <Form.Item label="Subscription" name={["subscriptionType"]} rules={[{ required: true, message: `Subscription is required` }]} hasFeedback>
                    <Input placeholder="Subscription type" readOnly={true} />
                </Form.Item>

                <Form.Item label="Start Date" name={["createdDate"]}>
                    <FormattedDateInput readOnly={true} />
                </Form.Item>

                <Form.Item label="Renewal Date" name={["renewalDate"]}>
                    <Input readOnly={true} />
                </Form.Item>

                <Form.Item label="Primary Contact" name={["primaryContactName"]} validateFirst={true} rules={nameRules}>
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Primary Contact Email"
                    name={["primaryContactEmail"]}
                    rules={[
                        {
                            required: true,
                            message: `Value is required`,
                        },
                        {
                            validator(_, value) {
                                if (value && value.toString().trim()) {
                                    if (validator.isEmail(value)) {
                                        return Promise.resolve();
                                    }
                                }
                                return Promise.reject(`Value should be a valid email`);
                            },
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <div className="col-span-2 flex justify-end">
                    <Button type="primary" htmlType="submit">
                        Save
                    </Button>
                </div>

                {onSetGoldenMaintenance && (
                    <div className="col-span-3 flex items-center gap-3" data-testid="admin-tenant-golden-maintenance">
                        <Popconfirm
                            title={goldenMaintenanceOn ? "Turn Golden Nominal maintenance off?" : "Turn Golden Nominal maintenance on?"}
                            description={
                                goldenMaintenanceOn
                                    ? "Deduplication goes back to deleting every subordinate record, and no golden records are created."
                                    : "Deduplication may create golden records, send uncertain clusters to review, and keep records from other datasets instead of deleting them."
                            }
                            okText={goldenMaintenanceOn ? "Turn off" : "Turn on"}
                            onConfirm={() => onSetGoldenMaintenance(tenant.tenantId, !goldenMaintenanceOn)}
                        >
                            <Switch
                                checked={goldenMaintenanceOn}
                                loading={switchingGoldenMaintenance}
                                aria-label="Golden Nominal maintenance"
                                data-testid="admin-tenant-golden-maintenance-switch"
                            />
                        </Popconfirm>
                        <div>
                            <Typography.Text strong>Golden Nominal maintenance</Typography.Text>
                            <div className="text-xs text-gray-500">
                                Golden records from duplicate clusters, the review of uncertain merges, and keeping records from other datasets. Off for existing tenants until turned on.
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Form>
    );
};

export default AdminTenantForm;
